<template>
	<div class="terms">{{ terms }}</div>
</template>

<script setup>
// eslint-disable-next-line no-undef
defineProps({
	terms: {
		type: String,
		required: true
	}
})
</script>

<style lang="scss" scoped>
.terms {
	text-align: center;
	margin-top: 1.3rem;
	font-size: 0.8rem;
	width: 90%;
	margin-left: auto;
	margin-right: auto;
	color: #6a6d82;
}
</style>
